<script setup>
  import { computed } from 'vue';
  import { useTidesStore } from "@/stores/TidesStore";
  import { intervalToDuration, isAfter } from 'date-fns'
  import Icon from './icons/Icon.vue';

  const tidesStore = useTidesStore();

  const nextEventTimeFromNow = computed(() => {
    const now = Date.now();
    const target =  tidesStore.nextTideEvent?.dateTime ? new Date(tidesStore.nextTideEvent.dateTime) : null;

    if (!isAfter(target, now)) return "now";

    const { hours, minutes } = intervalToDuration({ start: now, end: target });

    let parts = [];
    if (hours) parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);
    if (minutes) parts.push(`${minutes} min${minutes > 1 ? "s" : ""}`);

    return `in ${parts.join(" and ")}`;
  })  
</script>

<template>
  <div class="jwx-tide-spot__event-group" data-content="now-data">
    <div class="jwx-tide-spot__now-container">
      <div class="jwx-tide-spot__now-data">
        <p class="jwx-tide-spot__now-value">{{ tidesStore.nowTideValues[1] }} <span class="jwx-tide-spot__now-value-units">{{ tidesStore.selectedNearbyTideSpot.units }}</span></p>
        <Icon :name="tidesStore.nowTideValues[2] === 'rising' ? 'arrow-thin-up-right' : 'arrow-thin-down-right'" class="jwx-tide-spot__now-icon" />
      </div>
      <div v-if="tidesStore.nextTideEvent" class="jwx-tide-spot__next-event">
        <p class="jwx-tide-spot__next-event-label">Next</p>
        <p class="jwx-tide-spot__next-event-name">{{ tidesStore.nextTideEvent?.eventName }}</p>
        <p class="jwx-tide-spot__next-event-time">{{ nextEventTimeFromNow }}</p>
      </div>
    </div>
  </div>
</template>